import { FC } from 'react'

import useEmbroideryLogos from '../../../../../containers/EmbroideryContainer/useEmbroideryLogos'

import { AddEmbroideryLogo } from './AddEmbroideryLogo'
import { EmbroideryLogoSetup } from './EmbroideryLogoSetup'
import { LogoFormContainer } from './LogoFormContainer'

const LogoViewController = () => {
  const { displayLogoSetup } = LogoFormContainer.useContainer()

  return displayLogoSetup ? <EmbroideryLogoSetup /> : <AddEmbroideryLogo />
}

export const DTCLogoEmbroideryForm: FC = () => {
  const { userLogos, transientLogo, status } = useEmbroideryLogos()

  if (status === 'pending') return null

  return (
    <LogoFormContainer.Provider state={{ userLogos, transientLogo }}>
      <LogoViewController />
    </LogoFormContainer.Provider>
  )
}
